export const LOAD_PATIENT_START = 'patient/loadStart';
export const LOAD_PATIENT_DONE = 'patient/loadDone';
export const LOAD_PATIENT_FAIL = 'patient/loadFail';